const LIMIT_KEYS = Object.freeze({
  account_frequency: 'accountFrequency',
  global_frequency: 'globalFrequency',
  account_concurrency: 'accountConcurrency',
  global_concurrency: 'globalConcurrency',
  account_daily_calls: 'accountDaily',
  account_daily_work: 'accountDaily',
  global_daily_calls: 'globalDaily',
  global_daily_work: 'globalDaily',
})

/** Return only translated upload guidance and numeric retry hints, never server prose. */
export function uploadLimitGuidance(error) {
  if (error?.status !== 429 && !['RATE_LIMITED', 'http_429'].includes(error?.code) && error?.message !== 'authoring_limit_reached') return null
  const reason = error?.details?.reason
  const kind = Object.hasOwn(LIMIT_KEYS, reason) ? LIMIT_KEYS[reason] : 'unknown'
  const guidance = { key: `novelAuthoring.uploadLimits.${kind}`, retry_key: null, retry_params: {} }
  // A concurrency slot's lease is a recheck interval, not an availability promise.
  if (['account_concurrency', 'global_concurrency'].includes(reason)) return guidance
  const milliseconds = error?.details?.retry_after_ms
  if (typeof milliseconds !== 'number' || !Number.isFinite(milliseconds) || milliseconds <= 0) return guidance
  const [unit, divisor] = milliseconds >= 3_600_000 ? ['hours', 3_600_000]
    : milliseconds >= 60_000 ? ['minutes', 60_000] : ['seconds', 1_000]
  return { ...guidance, retry_key: `novelAuthoring.uploadLimits.${unit}`, retry_params: { count: Math.ceil(milliseconds / divisor) } }
}
